import clipboard from "./clipboard.js";

Alpine.magic('clipboard', clipboard);
